<app-header></app-header>
<div class="verify-email-page">
  <div class="container">
    <h2>Keep Calm and Verify Your Email :-)</h2>
      <p>
        {{ 'AUTH_ERROR.VERIFY_EMAIL_MESSAGE' | translate }}
        <br>
        <img class="mail-image" src="/assets/images/mail.svg" alt="Verification Image">
      </p>
    </div>
</div>